export default {
  title: '选择礼品',
};
